import { connect } from 'react-redux'

import styles from './HotelInfoBanner.module.scss'

const HotelInfoBanner = ({ hotel }) => {
  return (
    <div className={styles.container}>
      <div className={styles.banner}>
        <div className={styles.singleInfo}>
          <div className={styles.singleInfoName}>
            <span>Reservation hotline</span>
          </div>
          <span>{hotel.reservationHotLine}</span>
        </div>
        <div className={styles.singleInfo}>
          <div className={styles.singleInfoName}>
            <span>Hotel physical address</span>
          </div>
          <span>{hotel.invoiceAddress}</span>
        </div>
      </div>
    </div>
  )
}
const mapStateToProps = state => ({
  allHotels: state.login.subsidiaryList,
  currentHotelName: state.login.currentHotel
})

export default connect(mapStateToProps)(HotelInfoBanner)
